import { Link } from 'react-router';

import { EmptyState, ErrorState, LoadingState, PageHeader } from '@/components/PageHeader';
import { EntryStatusPill } from '@/components/StatusPill';
import { Card, Table } from '@/components/ui/table';
import { useCompanyBasics, useSession } from '@/features/auth/session';
import { addDaysOnly, fmtDateLong, todayInTz } from '@/lib/dates';
import { formatQuantity, hrs } from '@/lib/format';

import { useEntriesList } from './useEntries';

/** Foreman on web: read-only history of their own entries (doc 11). Owners/admins can use it too. */
export function HistoryPage() {
  const { user } = useSession();
  const { tz } = useCompanyBasics();
  const today = todayInTz(tz);
  const list = useEntriesList({
    foremanId: user.role === 'foreman' ? user.id : undefined,
    from: addDaysOnly(today, -60),
    to: today,
  });
  return (
    <>
      <PageHeader
        title="History"
        sub="Your last 60 days. Edits and approvals happen in the office."
      />
      {list.isPending ? (
        <LoadingState />
      ) : list.isError ? (
        <ErrorState error={list.error} onRetry={() => void list.refetch()} />
      ) : (
        <Card>
          <Table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Job</th>
                <th>Status</th>
                <th>Quantities</th>
                <th className="r">Labor h</th>
                <th className="r">Photos</th>
              </tr>
            </thead>
            <tbody>
              {list.data.items.length === 0 ? (
                <tr>
                  <td colSpan={6}>
                    <EmptyState>No entries in the last 60 days.</EmptyState>
                  </td>
                </tr>
              ) : null}
              {list.data.items.map((e) => (
                <tr key={e.id}>
                  <td>
                    <Link
                      to={`/entries/${e.id}`}
                      className="font-semibold text-orange-ink hover:underline"
                    >
                      {fmtDateLong(e.entryDate)}
                    </Link>
                  </td>
                  <td>{e.jobName}</td>
                  <td>
                    <EntryStatusPill status={e.status} />
                  </td>
                  <td className="num">
                    {e.quantitySummary
                      .map((q) => `${q.code} ${formatQuantity(q.quantity)} ${q.unit}`)
                      .join(' · ') || '—'}
                  </td>
                  <td className="r">{hrs(e.laborHours)}</td>
                  <td className="r">{e.photoCount}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card>
      )}
    </>
  );
}
